module.exports = __webpack_public_path__ + "img/img2.0de2b5da.png";